import { CSSProperties } from 'react';
import noop from '../../utils/noop';
import withTouchable from './withTouchable';

interface Props {
  activeOpacity?: number;
}

const TouchableOpacity = withTouchable<Props>(props => {
  return {
    opacity: props.activeOpacity,
  } as CSSProperties;
}, 'touchable-opacity');

const styleEl = document.createElement('style');

styleEl.innerHTML = `.touchable-opacity{
transition: opacity .2s ease;
}`;

document.head.appendChild(styleEl);

TouchableOpacity.defaultProps = {
  onTouch: noop,
  onClick: noop,
  disabled: false,
  activeOpacity: 0.7,
};

export default TouchableOpacity;
